import React from 'react';
import { projectTaskApi } from '../../../../../services/projectTasksApi';
import { ReactNode, useState } from 'react';
import { ExtendedProjectTask } from './types';
import TaskSelectionDialog from './TaskSelectionDialog';
import { Button, ClickAwayListener } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Assignment as TaskIcon } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

type TaskPickerProps = {
	icon?: ReactNode;
	selectTask: (task: ExtendedProjectTask | undefined) => void;
	buttonColor?: any;
};

const TaskPicker: React.FC<TaskPickerProps> = ({ selectTask, icon, buttonColor }) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [trigger] = projectTaskApi.endpoints.fetchTaskById.useLazyQuery();

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleSelectTask = async (task: ExtendedProjectTask) => {
		if (!task.projectTaskId) {
			return;
		}

		const { data } = await trigger({ taskId: task.projectTaskId });
		selectTask({ ...task, ...data });
		handleClose();
	};

	const open = Boolean(anchorEl);

	return (
		<ClickAwayListener onClickAway={handleClose}>
			<div style={{ position: 'relative', zIndex: 9999 }}>
				<Button
					onClick={handleClick}
					variant='text'
					startIcon={open ? <CloseIcon /> : <TaskIcon />}
					aria-expanded={Boolean(anchorEl)}
					aria-haspopup='true'
					color={buttonColor}
				>
					<FormattedMessage id='taskPicker.addTask' />
				</Button>
				<TaskSelectionDialog open={open} onClose={handleClose} onSelect={handleSelectTask} anchorEl={anchorEl} />
			</div>
		</ClickAwayListener>
	);
};

export default TaskPicker;
